import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setAccessPermissions, setUser } from './actions/index';
import Footer from './components/general/Footer';
import HeaderBar from './components/general/HeaderBar';
import EmpresaCard from './components/general/EmpresaCard';
import Login from './components/general/Login';
import Mantenimiento from './components/mantenimiento/Mantenimiento';
import Calidad from './components/Calidad';
import Inventario from './components/Inventario';
import Produccion from './components/Produccion'; 
import Registro from './components/general/Registro';
import CambiarContraseña from './components/general/CambiarContraseña';
import './variables.css';
import './App.css';

function App() {
  const User = useSelector((state) => state.auth);
  const permissions = useSelector((state) => state.access.permissions);
  const subMenu = useSelector((state) => state.menu.selectedSubMenu);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  // Restaura el estado del usuario desde sessionStorage al cargar la app
  useEffect(() => {
    const savedUser = JSON.parse(sessionStorage.getItem('user'));
    if (savedUser) {
      dispatch(setUser(savedUser)); // Restaura el usuario
      const perms = getPermissionsForUser(savedUser.Id_Access);
      dispatch(setAccessPermissions(perms)); // Restaura permisos
    }
    setLoading(false); // Indica que la inicialización terminó
  }, [dispatch]);

  // Guarda los datos del usuario en sessionStorage cada vez que cambien
  useEffect(() => {
    if (User.user) {
      sessionStorage.setItem('user', JSON.stringify(User.user));
    } else {
      sessionStorage.removeItem('user'); // Limpia sessionStorage si el usuario cierra sesión
    }
  }, [User.user]);

  useEffect(() => {
    if (!User.user) return;
    const perms = getPermissionsForUser(User.user.Id_Access);
    dispatch(setAccessPermissions(perms)); 
  }, [User.user]);

  const getPermissionsForUser = (accessId) => {
    switch (accessId) {
      case 1:
        return ['viewCalidad', 'viewMantenimiento', 'viewInventario', 'viewProduccion', 'updateMachines', 'deleteMachines', 'insertMachines'];
      case 2:
        return ['viewMantenimiento'];
      case 3:
        return ['viewMantenimiento', 'updateMachines', 'deleteMachines', 'insertMachines'];
      default:
        return [];
    }
  };

  const getDefaultAuthenticatedRoute = () => {
    if (permissions.includes('viewMantenimiento')) {
      return '/mantenimiento';
    } else if (permissions.includes('viewCalidad')) {
      return '/calidad';
    } else if (permissions.includes('viewInventario')) {
      return '/inventario';
    } else if (permissions.includes('viewProduccion')) {
      return '/produccion';
    } else {
      return '/login';
    }
  };

  if (loading) {
    // Muestra un mensaje de carga mientras se inicializa la aplicación
    return <div className="loading">Cargando...</div>;
  }

  return (
    <Router>
      <div className="App">
        {User.isAuthenticated && <HeaderBar userName={User.user?.Email_User || ''} />}
        {User.isAuthenticated && <EmpresaCard />}
        <Routes>
          {/* Ruta inicial */}
          <Route
            path="/"
            element={User.isAuthenticated ? <Navigate to={getDefaultAuthenticatedRoute()} /> : <Navigate to="/login" />}
          />
          {/* Rutas específicas */}
          <Route path="/home" element={User.isAuthenticated ? <Navigate to={getDefaultAuthenticatedRoute()} /> : <Navigate to="/login" />} />
          <Route path="/login" element={User.isAuthenticated ? <Navigate to={getDefaultAuthenticatedRoute()} /> : <Login />} />
          <Route path="/mantenimiento" element={User.isAuthenticated ? <Mantenimiento submenu={subMenu}/> : <Navigate to="/login" />} />
          <Route path="/calidad" element={User.isAuthenticated ? <Calidad submenu={subMenu}/> : <Navigate to="/login" />} />
          <Route path="/inventario" element={User.isAuthenticated ? <Inventario submenu={subMenu}/> : <Navigate to="/login" />} />
          <Route path="/produccion" element={User.isAuthenticated ? <Produccion submenu={subMenu}/> : <Navigate to="/login" />} />
          <Route path="/registro" element = {<Registro/>  } />
          <Route path="/password" element={<CambiarContraseña opcion='olvidar-contraseña'/>} />
          <Route path="/password1" element={<CambiarContraseña opcion='cambiar-contraseña'/>} />
          {/* Ruta para no encontrados */}
          <Route path="*" element={<Navigate to={User.isAuthenticated ? getDefaultAuthenticatedRoute() : "/login"} />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
